import { Navigate, useSearchParams } from "react-router-dom";
import { Bot, FileText, FolderCog, FolderOpen, KeyRound, UserRound } from "lucide-react";
import { useAuth } from "../auth";
import { AiSettings } from "../components/AiSettings";
import { CategorySettings } from "../components/CategorySettings";
import { PersonalSettings } from "../components/PersonalSettings";
import { TokenManager } from "../components/TokenManager";
import { MyArticles } from "../components/MyArticles";
import { CollectionSettings } from "../components/CollectionSettings";

export function Settings() {
  const { user, loading } = useAuth();
  const [params, setParams] = useSearchParams();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  const requested = params.get("tab") || "";
  const allowed = [
    "profile",
    "api",
    "ai",
    "articles",
    "collections",
    ...(user.role === "admin" ? ["categories"] : []),
  ];
  const tab =
    requested === "mcp"
      ? "api"
      : allowed.includes(requested)
        ? requested
        : "profile";
  const menu = [
    { id: "profile", label: "个人设置", icon: UserRound },
    { id: "api", label: "API 设置", icon: KeyRound },
    { id: "ai", label: "AI 设置", icon: Bot },
    { id: "articles", label: "我发布的文章", icon: FileText },
    { id: "collections", label: "我的合集", icon: FolderOpen },
    ...(user.role === "admin"
      ? [{ id: "categories", label: "文章分类设置", icon: FolderCog }]
      : []),
  ];
  return (
    <div className="max-w-7xl mx-auto px-5 py-10 grid md:grid-cols-[220px_1fr] gap-8">
      <aside>
        <h1 className="text-2xl font-bold mb-5">设置中心</h1>
        <nav className="space-y-1">
          {menu.map((item) => (
            <button
              key={item.id}
              onClick={() => setParams({ tab: item.id })}
              className={`w-full h-11 px-3 rounded-lg flex items-center gap-3 text-sm ${tab === item.id ? "bg-primary text-white" : "hover:bg-[var(--bg-hover)]"}`}
            >
              <item.icon className="w-4 h-4" />
              {item.label}
            </button>
          ))}
        </nav>
      </aside>
      <main className="min-w-0">
        {tab === "profile" && <PersonalSettings user={user} />}{" "}
        {tab === "api" && <TokenManager />} {tab === "ai" && <AiSettings />}{" "}
        {tab === "categories" && user.role === "admin" && <CategorySettings />}
        {tab === "articles" && <MyArticles />} {tab === "collections" && <CollectionSettings />}
      </main>
    </div>
  );
}
